<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('advertismentReport.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active ms-2 almarai-bold me-2" aria-current="page">
              {{$t('advertismentReport.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-lg-8">
            <success v-if="succesfuly" :message="succesMessage" />
          </div>
        </div>

        <div class="row justify-content-center py-4">
          <div class="col-12 col-lg-8">
            <div class="card blog-card card-groundcolor">
              <div class="card-body">
                <form action="">
                  <div class="row">
                    <div class="col">
                      <label for="">{{$t('advertismentReport.reason')}}</label>
                      <select v-model="reasonId" class="form-select input-style">
                        <option v-for="(row, index) in rows" :key="index" :value="row.id">{{row.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row pt-4">
                    <div class="col position-R">
                      <!-- <label for="">{{$t('complains.title_3')}}</label> -->
                      <textarea v-model="subject" class="br-radius form-control" :placeholder="$t('advertismentReport.writeReport')"  rows="3"></textarea>
                    </div>
                  </div>
                  <div class="row py-4 justify-content-center">
                    <div class="col-6 text-center">
                      <div v-if="isLoading" class="text-center">
                        <loader />
                      </div>
                      <button v-else @click.prevent="complains" class="btn-green form-control">
                        {{$t('advertismentReport.btnConfrim')}}
                      </button>
                    </div>

                    <div class="col-6">
                      <router-link :to="'/propertydetails/'+this.rowId">
                        <div class="btn-white">{{$t('advertismentReport.btnCancel')}}</div>
                      </router-link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'advertismentReport',
  data(){
    return {
      rowId: this.$route.query.rowId,
      isLoading: false,
      hasError: false,
      errorNumber: 0,
      message: "",
      succesMessage: "",
      succesfuly: false,
      rows: [],
      reasonId: null,
      subject: "",
      userLang: 'ar',
    }
  },
  methods: {
    complains(){
      this.hasError = false;
      this.succesfuly = false;
      this.isLoading = true;
      this.$http.post("/api/complains/create",{
        modelName: "Properties",
        rowId: parseInt(this.rowId),
        reasonId: this.reasonId,
        subject: this.subject,
      }).then(res => {
        // console.log(res);
        this.succesMessage = "استلمنا بلاغك وجاري التحقق منه";
          this.succesfuly = true;
        setTimeout(()=> {
          this.succesfuly = false;
        },2000)
        this.reasonId = null,
        this.subject = ''
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    reasonsList(){
      this.$http.get('/api/complains/getReasons').then(res => {
        // console.log(res);
        this.rows = res.data.rows;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    }
    
    
  },
  created(){
    this.reasonsList();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>